import type { Locale } from "../../lib/i18n";
import { getTranslations } from "../../lib/i18n";

type AppPromptModalProps = {
  dynamicLink: string;
  onClose: () => void;
  onOpenApp: () => void;
  locale: Locale;
};

function FestAppLogo() {
  return (
    <svg
      className="festapp-app-prompt-logo-svg"
      width="64"
      height="64"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="512" height="512" rx="112" fill="black" />
      <g transform="translate(84, 84) scale(1.1)">
        <path
          d="M0.25 312.737H32.6355C36.698 312.737 63.948 314.601 88.6875 273.708C113.427 232.815 140.667 234.669 144.729 234.669H312.75V156.497H205.302C201.24 156.497 173.99 154.633 149.25 195.526C124.51 236.419 97.271 234.555 93.2085 234.555H0.25V312.737Z"
          fill="url(#fest_gradient_bottom)"
        />
        <path
          d="M312.75 0.26302H280.375C276.313 0.26302 249.052 -1.60144 224.323 39.2917C199.594 80.1849 172.333 78.3205 168.271 78.3205H0.25V156.441L107.729 156.503C111.792 156.503 139.052 158.368 163.781 117.474C188.51 76.581 215.74 78.383 219.802 78.383H312.75V0.26302Z"
          fill="url(#fest_gradient_top)"
        />
      </g>
      <defs>
        <radialGradient
          id="fest_gradient_bottom"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-93.3329 339.282) rotate(-26.9166) scale(490.561 396.076)"
        >
          <stop offset="0.119501" stop-color="#CA1800" />
          <stop offset="0.579966" stop-color="#F85040" />
          <stop offset="1" stop-color="#FF8D53" stop-opacity="0.9" />
        </radialGradient>
        <radialGradient
          id="fest_gradient_top"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-93.333 183.048) rotate(-26.9166) scale(490.561 396.076)"
        >
          <stop offset="0.119501" stop-color="#CA1800" />
          <stop offset="0.579966" stop-color="#F85040" />
          <stop offset="1" stop-color="#FF8D53" stop-opacity="0.9" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function AppPromptModal({
  onClose,
  onOpenApp,
  locale,
}: AppPromptModalProps) {
  const t = getTranslations(locale);

  return (
    <div className="festapp-app-prompt-overlay" onClick={onClose}>
      <div
        className="festapp-app-prompt-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="festapp-app-prompt-logo">
          <FestAppLogo />
        </div>
        <p className="festapp-app-prompt-text">{t.appPromptMessage}</p>
        <div className="festapp-app-prompt-buttons">
          <button
            type="button"
            className="festapp-btn festapp-btn-md"
            style={{
              background: "var(--festapp-fg)",
              color: "var(--festapp-bg)",
              boxShadow: "var(--festapp-shadow-md)",
            }}
            onClick={onOpenApp}
          >
            {t.openApp}
          </button>
          <button
            type="button"
            className="festapp-btn festapp-btn-ghost festapp-btn-md"
            onClick={onClose}
          >
            {t.cancel}
          </button>
        </div>
      </div>
    </div>
  );
}
